import { CSSObjectWithLabel, GroupBase, OptionProps, StylesConfig } from 'react-select';

import globalTheme from '../../theme';
import { Option } from '../types';
import { commonTheme } from './theme';

const brunoTheme: StylesConfig<Option, false, GroupBase<Option>> = {
  ...commonTheme,
  option: (base: CSSObjectWithLabel, props: OptionProps<Option, false, GroupBase<Option>>) => ({
    ...base,
    display: 'block',
    width: '100%',
    cursor: 'pointer',
    position: 'relative',
    flexDirection: 'row',
    fontSize: '14px',
    padding: `13.5px ${globalTheme.spacers!.spacer05}`,
    lineHeight: '21px',
    background: props.isSelected
      ? globalTheme.admanColors!.blue.light.bg[0]
      : globalTheme.admanColors!.gray.light.bg0[0],
    color: props.isSelected ? globalTheme.admanColors!.gray.light.fg[0] : globalTheme.admanColors!.gray.light.fg[1],
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    height: '45px',
    '&:after': {
      content: '""',
      display: 'block',
      bottom: 0,
      position: 'absolute',
      width: '100%',
      left: 0,
    },
    '&:hover': {
      background: props.isSelected
        ? globalTheme.admanColors!.blue.light.bg[1]
        : globalTheme.admanColors!.gray.light.bg0[1],
    },
  }),
};

export default brunoTheme;
